import { render, staticRenderFns } from "./nearbyShop.vue?vue&type=template&id=24087584&scoped=true"
import script from "./nearbyShop.vue?vue&type=script&lang=js"
export * from "./nearbyShop.vue?vue&type=script&lang=js"
import style0 from "./nearbyShop.vue?vue&type=style&index=0&id=24087584&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24087584",
  null
  
)

export default component.exports